module.exports = __webpack_public_path__ + "static/media/essential-sphere.329a957f.svg";